/**
 * Compte les groupes OptionProduit actifs pour le badge liste Admin.
 * Aligné sur backend/utils/produitsUtils.resolveProduitOptionsCount.
 */

export function resolveProduitOptionsCount(produit) {
  if (!produit || typeof produit !== 'object') return 0;
  if (Number.isFinite(produit.optionsCount) && produit.optionsCount >= 0) {
    return Math.floor(produit.optionsCount);
  }
  if (Number.isFinite(produit._count?.options) && produit._count.options >= 0) {
    return Math.floor(produit._count.options);
  }
  if (Array.isArray(produit.options)) {
    return produit.options.filter((o) => o && o.actif !== false).length;
  }
  return 0;
}

export function formatProduitOptionsBadgeLabel(optionsCount) {
  const n = Math.max(0, Math.floor(Number(optionsCount) || 0));
  if (n <= 0) return null;
  return `${n} option${n > 1 ? 's' : ''}`;
}
